import { Component, Input, OnInit } from "@angular/core";
import { MediaSegmentsViewModel } from "./media-segments.view-model";

@Component({
  selector: "evrideo-media-segments",
  templateUrl: "./media-segments.component.html",
  styleUrls: ["./media-segments.component.scss"],
})
export class MediaSegmentsComponent implements OnInit {
  @Input()
  vm: MediaSegmentsViewModel;

  constructor() {}

  ngOnInit(): void {}
}
